import { render } from "./IncidenciasPage.vue?vue&type=template&id=1349c222&scoped=true"
import script from "./IncidenciasPage.vue?vue&type=script&lang=js"
export * from "./IncidenciasPage.vue?vue&type=script&lang=js"

import "./IncidenciasPage.vue?vue&type=style&index=0&id=1349c222&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1349c222"]])

export default __exports__